import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Util} from 'yougile-util'
import {EventBus} from '@client/event-bus'
import {openProjectParticipants} from '@client/events'
import {SharedBoardsClient} from '@client/shared-boards-client'
import {Tracking, TrackingEvent} from '@common/tracking'
import {AvatarGroup} from '@components/common/base/avatar'
import {IconButton} from '@components/common/base/buttons'
import {NotificationCenter} from '@components/notification-center'
import {PredefinedFilter} from '@components/right-panel/search/search-store'
import {Logo} from '@components/upper-panel/logo'
import {withUpdaters} from '@containers/updaters'
import {LocationUpdater} from '@containers/updaters/location-updater'
import {SyncUpdater} from '@containers/updaters/sync-updater'
import {PageService} from '@extensions/page-service'
import {UserAccess} from '@extensions/user-access'
import {NetworkWarning} from '../network-warning'
import {SearchTop} from '../right-panel/search/search-top'

const TwUpperPanel = tw.div`
  flex
  items-center
  h-32
  gap-16
  pr-42
  pl-12
`

const TwProjectName = tw.div`
  flex-none
  text-sm-semibold
  text-panel-text-primary
`

const TwProjectUsers = tw.div`
  flex-none
  flex
  items-center
  gap-8
`

const availablePredefinedFilters: PredefinedFilter[] = [
  'everywhere',
  'task-titles',
  'current-project',
  'custom'
]

const UpperPanelBase = () => {
  const project = PageService.getCurrentProject()
  const isShared = SharedBoardsClient.getId()
  const canEditUsers = UserAccess.canChangeUserInProject(project)
  const showAddUser = () => {
    EventBus.dispatch(openProjectParticipants(project))
    void Tracking.send(TrackingEvent.boardClickOnAvatarDeckInHeader)
  }
  const users = UserAccess.listUsersInProject(project)

  return project ? (
    <TwUpperPanel>
      <TwProjectName>
        {isShared
          ? Util.limitStr(project.title, 80)
          : `${Lang.msg.project} “${Util.limitStr(project.title, 20)}”`}
      </TwProjectName>
      {!isShared && <NotificationCenter />}
      {!isShared && (
        <TwProjectUsers>
          <AvatarGroup
            userIds={users.map(x => x.id)}
            size={20}
            outlineColor="panel-outline-badge"
            badgeVariant="panel"
            onClick={canEditUsers ? showAddUser : undefined}
          />
          {canEditUsers && (
            <IconButton
              icon="IconPlus"
              color="panelIconSecondary"
              size="small"
              wrapperSize="big"
              className="-mx-4"
              onClick={showAddUser}
            />
          )}
        </TwProjectUsers>
      )}
      <SearchTop
        defaultPredefinedFilter="current-project"
        availablePredefinedFilters={availablePredefinedFilters}
      />
      <NetworkWarning />
      {isShared && <Logo className="ml-auto" />}
    </TwUpperPanel>
  ) : null
}

export const UpperPanel = withUpdaters(
  SyncUpdater({companyType: 'current', filter: '*', debounceTime: 1000}),
  LocationUpdater({ignoreChat: true})
)(UpperPanelBase)
